import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { stylesShareSite } from "../../shareSiteStylesMui/ShareSiteStylesMuiComponents";

import { StoragesData } from "../../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteSortStoragesParams = {
  setStorages: (values: StoragesData) => void;
  setSelectedSort: (values: string) => void;
  storages: StoragesData;
  selectedSort: string;
};

const ShareSiteSortStorage: FC<ShareSiteSortStoragesParams> = ({
  setStorages,
  setSelectedSort,
  storages,
  selectedSort,
}) => {
  const [t] = useTranslation("global");
  const handleChange = (event: SelectChangeEvent) => {
    setSelectedSort(event.target.value);
    if (event.target.value === "by-used-capacity") {
      setStorages({
        ...storages,
        data: storages.data.toSorted((a): number => {
          if (a.usedCapacity.value) return -1;
          return 0;
        }),
      });
    }

    if (event.target.value === "by-no-used-capacity") {
      setSelectedSort(event.target.value);
      setStorages({
        ...storages,
        data: storages.data
          .toSorted((a): number => {
            if (a.usedCapacity.value) return 1;
            return 0;
          })
          .reverse(),
      });
    }
  };

  return (
    <div>
      <Box>
        <FormControl
          disabled={storages.data.length === 0}
          sx={stylesShareSite.filterInputs}
          fullWidth
        >
          <FormControl fullWidth>
            <InputLabel id="storage-sort-by-capacity"></InputLabel>
            <Select
              variant="standard"
              labelId="storage-sort-by-capacity"
              value={selectedSort}
              onChange={handleChange}
            >
              <MenuItem value={"by-used-capacity"}>
                {t("Share_site.sort-by-text-3")}
              </MenuItem>
              <MenuItem value={"by-no-used-capacity"}>
                {t("Share_site.sort-by-text-2")}
              </MenuItem>
            </Select>
          </FormControl>
        </FormControl>
      </Box>
    </div>
  );
};

export default ShareSiteSortStorage;
